import { ProfileIdentificationStatusAPIModel } from '@/generated/api/fps/api';
import { PhoneAPIModel } from '@/generated/api/fps/core';
import { PhoneType, Value } from '@/model/common';

export const NAMESPACE = 'IDENTIFICATION';

export enum IdentificationUIState {
  LOGIN = 'login',
  CONFIRMATION = 'confirmation',
}

export enum IdentificationState {
  NOT_PASSED = 'NOT_PASSED',
  PASSED = 'PASSED',
}

export enum ConfirmationState {
  IN_PROGRESS = 'IN_PROGRESS',
  WRONG_CODE = 'WRONG_CODE',
  ATTEMPTS_NUMBER_EXHAUSTED = 'ATTEMPTS_NUMBER_EXHAUSTED',
  EXPIRED = 'EXPIRED',
  PASSED = 'PASSED',
}

export type PhoneInfo = PhoneAPIModel;

export interface Confirmation {
  state: ConfirmationState;
  phone: PhoneType;
  attempt?: number;
  validTill?: Date;
  resendAfter?: Date;
}

export interface PhoneValue extends Value<string> {
  modified: boolean;
}

export interface State {
  phone?: PhoneValue;
  savedPhone?: PhoneType;
  confirmation?: Confirmation;
  profileIdentificationStatus?: ProfileIdentificationStatusAPIModel;
  state?: IdentificationState;
  initialized: boolean;
}

export const initialState: State = {
  initialized: false,
};
